import type { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';
import { clamp } from 'lodash';

interface ProgressBarProps extends ComponentPropsWithoutRef<'div'> {
  min?: number;
  max?: number;
  value?: number;
  indicatorAriaLabel?: string;
  progressClassName?: string;
}

/**
 * @deprecated For new features, use ProgressBar from the new ui-kit
 */
const ProgressBar = ({
  className,
  progressClassName,
  value = 0,
  min = 0,
  max = 100,
  indicatorAriaLabel,
  ...props
}: ProgressBarProps) => {
  const clampedValue = clamp(value, min, max);
  const scaleX = (100 / (max - min)) * (clampedValue - min);

  return (
    <div className={classNames('progress-bar-deprecated', className)} {...props}>
      <div
        role="progressbar"
        className={classNames('progress-bar-deprecated-indicator', progressClassName)}
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-label={indicatorAriaLabel}
        style={{
          transform: `scaleX(${scaleX}%)`,
        }}
      />
    </div>
  );
};

export default ProgressBar;
